module.exports = __webpack_public_path__ + "img/shape-8-gold@2x.2bf8954c.png";